import React from "react";
import { navigate } from "@gatsbyjs/reach-router";

const ApplicantUploadIndex = (props: any) => {
    navigate("/applicant/new/upload");
    return null;
};

export default ApplicantUploadIndex;
